<template>
  <div class="rights">
    <img src="../../assets/images/logo-bg.png"
         class="rights-logo"
         draggable="false"
         alt="">
    <h1 class="rights-title">办公模版属于猎豹安全浏览器专属功能</h1>
    <h2 class="rights-subtitle">建议安装猎豹安全浏览器后使用</h2>
    <button v-if="isLiebao" class="rights-download" @click="handleDownload">立即升级</button>
    <button v-else class="rights-download" @click="handleDownload">立即下载</button>
    <ul class="rights-list">
      <li class="rights-item">
        <img src="../../assets/icon/rights/ppt.png"
             class="rights-item-icon"
             alt="">
        <h3 class="rights-item-des">PPT模板</h3>
      </li>
      <li class="rights-item">
        <img src="../../assets/icon/rights/excel.png"
             class="rights-item-icon"
             alt="">
        <h3 class="rights-item-des">Excel模板</h3>
      </li>
      <li class="rights-item">
        <img src="../../assets/icon/rights/intro.png"
             class="rights-item-icon"
             alt="">
        <h3 class="rights-item-des">简历模板</h3>
      </li>
      <li class="rights-item">
        <img src="../../assets/icon/rights/image.png"
             class="rights-item-icon"
             alt="">
        <h3 class="rights-item-des">精美图库</h3>
      </li>
    </ul>
  </div>
</template>
<script>
import { isLiebao } from '@/utils'

export default {
  name: 'Rights',
  data () {
    return {
      isLiebao: isLiebao,
    }
  },
  methods: {
    handleDownload () {
      window.open('https://www.liebao.cn/', '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/style/styleMixins";
.rights {
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #4373FF;
  .flex_center_mixins;
  flex-direction: column;
  &-logo{
    height: 273px;
  }
  &-title{
    font-size: 44px;
    color: #FFFFFF;
    line-height: 50px;
    letter-spacing: 4px;
  }
  &-subtitle{
    font-size: 16px;
    color: #FFFFFF;
    line-height: 18px;
    letter-spacing: 2px;
    margin-top: 15px;
  }
  &-download{
    .clear_button_default_mixins;
    padding: 9px  50px;
    font-size: 20px;
    font-weight: bold;
    color: #4373FF;
    background-color: #FFFFFF;
    border-radius: 22px;
    border-width: 0;
    margin-top: 24px;
    transition: background-color .3s;
    &:hover{
      background-color:  #D1ECFF;
    }
    &:focus{
      background-color: #A9D8FF;;
    }
  }
  &-list{
    .flex_align_center_mixins;
    margin-top: 88px;
  }
  &-item{
    margin-right: 12px;
    padding: 26px 40px;
    background: #FFFFFF;
    border-radius: 4px;
    .flex_justify_center_mixins;
    flex-direction: column;
    &-icon{
      height: 70px;
      width: 70px;
      margin-bottom: 15px;
    }
    &-des{
      text-align: center;
      font-size: 14px;
      color: #3C3E40;
    }
  }
}
</style>
